import { render, staticRenderFns } from "./JudgeResultModal.vue?vue&type=template&id=5e1e8e45&scoped=true&"
import script from "./JudgeResultModal.vue?vue&type=script&lang=js&"
export * from "./JudgeResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1e8e45",
  null
  
)

export default component.exports